/* @jsx jsx */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';

import { Grid, breakpoints } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import type { Maybe } from 'bundles/premium-certificate/__generated__/baseContentfulTypes';

type Props = {
  name?: Maybe<string>;
  position?: Maybe<string>;
  profilePicture?: Maybe<{ url?: Maybe<string> }>;
};

const styles: Record<string, Interpolation<Theme>> = {
  instructorInfo: () => css`
    margin-top: 1rem;

    @media (max-width: ${breakpoints.values.md}px) {
      margin-top: 0;
    }
  `,
  instructorName: () => css`
    font-family: inherit;
    font-weight: 700;
    font-size: 1.25rem;
    line-height: 1.5rem;

    @media (max-width: ${breakpoints.values.md}px) {
      font-size: 1rem;
      line-height: 1.875rem;
    }
  `,
  instructorPosition: () => css`
    font-size: 1rem;
    line-height: 1.875rem;
    font-family: inherit;

    @media (max-width: ${breakpoints.values.md}px) {
      font-size: 0.75rem;
      line-height: 1.125rem;
    }
  `,
  instructorProfile: () => css`
    display: flex;
    margin-top: 1rem;
    margin-bottom: 3rem;
    padding-right: 4rem;

    @media (max-width: ${breakpoints.values.md}px) {
      top: 0;
      margin-bottom: 1.5rem;
      padding: 0;
    }
  `,
  profilePictureContainer: () => css`
    margin-right: 1.5rem;

    > img {
      width: 7rem;
      height: 7rem;
      border-radius: 50%;
    }

    @media (max-width: ${breakpoints.values.md}px) {
      margin-bottom: 1rem;

      img {
        width: 4.5rem;
        height: 4.5rem;
      }
    }
  `,
};

const CertificateInstructor = ({ name, position, profilePicture }: Props) => {
  return (
    <Grid item md={6}>
      {profilePicture?.url && (
        <div data-test="InstructorProfile" css={styles.instructorProfile}>
          <div css={styles.profilePictureContainer}>
            <img src={profilePicture.url} alt={`${name}`} />
          </div>
          <div css={styles.instructorInfo}>
            <p css={styles.instructorName}>{name}</p>
            <p css={styles.instructorPosition}>{position}</p>
          </div>
        </div>
      )}
    </Grid>
  );
};

export default CertificateInstructor;
